import { getCountries, getCountryCallingCode } from 'libphonenumber-js';

export function getAreaCodes(): string[] {
    const countryCodes = getCountries();
    const areaCodes = countryCodes.map((countryCode) => parseInt(getCountryCallingCode(countryCode)));
    // sort from lowest to highest
    const areaCodesSorted = areaCodes.sort((a, b) => a - b);
    // remove duplicates
    const areaCodesUnique = [...new Set(areaCodesSorted)];
    // convert to strings and add + foward
    const areaCodesUniqueStrings = areaCodesUnique.map((areaCode) => '+' + areaCode.toString());
    // return
    return areaCodesUniqueStrings;
}